import React from "react";
import { Link } from "react-router-dom";

import "./style.css";
import "./noitedia.css";
import "./menu.css";

import lampadaSVG from "../../assets/images/logo_lampada_by_dj.svg"

import {useContext} from 'react';
import {UserContext} from '../../hooks/UserContext'

import {MHeaderV2} from '../MHeader'
import {HeaderSelect} from '../MHeader/styled'

import {findDocumentos} from "../../bd/documentos"

function Header(){

    return (
        <HeaderSelect>
          <div className="header-pc"><PCHeader/></div>
          <div className="header-m"><MHeaderV2/></div>
        </HeaderSelect>
    );
}

function PCHeader() {
  // eslint-disable-next-line
  return <Main_header_noite {...Main_header_noiteData} />;
}

export default Header;

function Main_header_noite(props) {
  const { user } = useContext(UserContext);
  const {
    logoImg,
    nome_plataforma,
  } = props;

  const BtnAdm = (
    <li>
      {/* <Link  to='/dj/adm'> Resetar Senhas </Link> */}
      <Link  to='/admMenu' className="novo"> ADM - Atalhos </Link>
    </li>
  )
//className="poppins-normal-alice-blue-35px"
  const BtnProf =(<li><Link  to='/Supervisorio'>
      Supervisório
  </Link></li>)

  return (
    <div className="pcnavbar">
      <div className="main-header">
        <Link className="main-header-logo" to=''>
          {/* <Link to='/'  className="lamda"> */}
          <img className="lamda" src={logoImg} alt="Inova Maranhão" />
          {/* </Link> */}
          {/* <Link to='/'> */}
          <h1 className="inovonline valign-text-middle">{nome_plataforma}</h1>
          {/* </Link> */}
        </Link>
        {/* <div> */}

        <div className="djmenu menu-group cor-txt-n1b">
          {
            //<li className="/*menu1*/ valign-text-middle poppins-normal-alice-blue-35px">
            //</div><Link Link to="/Login/Home">HOME</Link>
            //</li>
          }
          <li className="/*menu1*/ djmenu-1 valign-text-middle poppins-normal-alice-blue-35px">
            <div /*to="/"*/ className="novo">Explore</div>
            <ul className="djsub-menu">
              <li><a target="_blank" rel="noreferrer" href={linkSobre}>Sobre o Inova Maranhão e o Maratoninha Maker</a></li>
              <li><Link to="/Ranking">RANKING</Link></li>
              <li><Link to="/Cadastros">Cadastros</Link></li>
              <li><Link to="/Planetas/">Missões</Link></li>
              {!!user &&
                <li><Link to="/Certificados/" className="novo">Certificados</Link></li>
              }
              {user?.patente>=3 && BtnAdm}
              {user?.patente>=2 && BtnProf}
            </ul>
          </li>
          <li className="/*menu2*/ djmenu-1 valign-text-middle poppins-normal-alice-blue-35px">
            <div /*to="/"*/>Ferramentas</div>
            <ul className="djsub-menu">
              <li>{"Online"}</li>
              <li><a target="_blank" rel="noreferrer" href="http://wokwi.com">{"  Wokwi"}</a></li>
              <li><a target="_blank" rel="noreferrer" href="https://www.tinkercad.com/dashboard?type=circuits&collection=designs">{"  TinkerCAD"}</a></li>
              <li><a target="_blank" rel="noreferrer" href="http://create.arduino.cc/editor">{"  Arduino Editor"}</a></li>
              <li>{"Offiline"}</li>
              <li><a target="_blank" rel="noreferrer" href="https://inovonline.vercel.app/img/baixar/fritzing-548.64.pc.exe">{"   Fritizzing"}</a></li>
              <li><a target="_blank" rel="noreferrer" href="https://www.arduino.cc/en/software">{"   ArduinoIDE"}</a></li>
            </ul>
          </li>

          <li className="/*menu3*/ valign-text-middle poppins-normal-alice-blue-35px">
            <Link to="/Duvidas">Tire dúvidas no ZAP</Link>
          </li>
          {/* <a href="https://wa.me/5598991296071/?text=oi, vim pela plataforma">Dúvidas?</a> */}
          <li className="adm-menu">
            {/* {user?.patente>=3 && BtnAdm} */}
            {/* {user?.patente>=2 && BtnProf} */}
          </li>
          {/*
            <div className="menu2 valign-text-middle poppins-normal-alice-blue-35px">menu2</div>
            <div className="ajuda valign-text-middle poppins-normal-alice-blue-35px">SOBRE</div>
          */}
        </div>
        {/* </div> */}
        {/*
          <div className="gpM">
          <nav className="menu-group menu">
            <li className="menu1 valign-text-middle poppins-normal-alice-blue-35px">
          <a>MUNDOS</a>
          <ul className="djsub-menu">
          <li><a className="submenu1 valign-text-middle poppins-normal-alice-blue-35px" href="#">Mundo 1</a></li>
          <li><a className="submenu1 valign-text-middle poppins-normal-alice-blue-35px" href="#">Mundo 2</a></li>
          <li><a className="submenu1 valign-text-middle poppins-normal-alice-blue-35px" href="#">Mundo 3</a></li>
          <li><a className="submenu1 valign-text-middle poppins-normal-alice-blue-35px" href="#">Mundo 4</a></li>
          </ul>
            </li>

            <li className="menu2 valign-text-middle poppins-normal-alice-blue-35px">menu2</li>
            <li className="ajuda valign-text-middle poppins-normal-alice-blue-35px">ajuda</li>
          </nav>
          </div>
        */}
        {/*

          <ul id="nav">
          <li><a href="#">Home</a></li>
          <li><a href="#">Sobre</a></li>
          <li><a href="#">O que Fazemos?</a>
            <ul className="djsub-menu">
          <li><a href="#">Web Design</a></li>
          <li><a href="#">Hospedagem</a></li>
          <li><a href="#">SEO</a></li>
          <li><a href="#">Sistemas</a></li>
            </ul>
          </li>

          <li><a href="#">Contato</a></li>
          </ul>
        */}
        {/* <div className="menu-pts">100</div> */}
        <NoiteDia/>
        <Config/>
      </div>
    </div>
  );
}


function Config() {
  const documentos = findDocumentos()
    .map(
      (doc,i)=> <li key={doc[0]}>
        <div>
          <a target="_blank" rel="noreferrer" className="poppins-normal-alice-blue-16px" href={doc[1]}>
            {"    "}
            <span className="fi-br-file"/>
            <span>{doc[0]}</span>
          </a>
        </div>
      </li>
    )
  return (
    <div className="config-menu djmenu menu-group cor-txt-n1b">
      <li className="valign-text-middle">
        <i className="fi fi-br-menu-burger"/>
        <ul className="djsub-menu poppins-normal-alice-blue-35px">

          <div className="valign-text-middle ">
            <div> Documentos </div>
            {documentos}
          </div>
          <div><hr/></div>

          <div><hr/></div>
          <li>
            <Link className="" to="/Sair">
              <span className="fi fi-rr-power"/>
              <span>Sair</span>
            </Link>
          </li>
        </ul>
      </li>
    </div>
  );
}


const Main_header_noiteData = {
    logoImg :lampadaSVG,
    nome_plataforma: "InovOnline",
};

// const noiteData = {
//     vector: "https://anima-uploads.s3.amazonaws.com/projects/5ff7c137a976a64adc4f9477/releases/60104f03510fa6345b29f361/img/vector@2x.png",
//     vector2: "https://anima-uploads.s3.amazonaws.com/projects/5ff7c137a976a64adc4f9477/releases/60104f03510fa6345b29f361/img/vector-1@2x.png",
//     vector3: "https://anima-uploads.s3.amazonaws.com/projects/5ff7c137a976a64adc4f9477/releases/60104f03510fa6345b29f361/img/vector-2@2x.png",
//     vector4: "https://anima-uploads.s3.amazonaws.com/projects/5ff7c137a976a64adc4f9477/releases/60104f03510fa6345b29f361/img/vector-3@2x.png",
//     vector5: "https://anima-uploads.s3.amazonaws.com/projects/5ff7c137a976a64adc4f9477/releases/60104f03510fa6345b29f361/img/vector-4@2x.png",
//     group: "https://anima-uploads.s3.amazonaws.com/projects/5ff7c137a976a64adc4f9477/releases/60104f03510fa6345b29f361/img/group@2x.png",
// };



function NoiteDia() {
  // const {vector,
  //   vector2,
  //   vector3,
  //   vector4,
  //   vector5,
  //   group} = noiteData;
  return (
  <div className="noitedia-menu">
    <div className="gp-menu-noitedia" style={!!desativarNoiteDia? {display:"none"} : {}}>
      <div className="sum">
        <div className="overlap-group2">
          {/* <img alt= "vector" className="vector" src={vector} />
          <img alt= "vector-1" className="vector-1" src={vector2} />
          <img alt= "vector-2" className="vector-2" src={vector3} />
          <img alt= "vector-3" className="vector-3" src={vector4} />
          <img alt= "vector-4" className="vector-4" src={vector5} />
          <img alt= "group" className="group" src={group} /> */}
        </div>
      </div>
      <div className="rectangle-16"></div>
    </div>
  </div>
  );
}

const desativarNoiteDia = true;
const linkSobre = "https://www.canva.com/design/DAEy3MBaXQU/4mn3CvmHv8MSuNySdbRd5Q/view?website#2"
